import type { OrganizationSizeValue } from '@hotjar/webapp/hooks/useOrganizationSizeChoices';
import type { Role as OrganizationRoleValue } from '@hotjar/webapp/features/Activation/OnboardingPage/steps/OrganizationSteps/steps/OrganizationRole';
import { getGroupedOrgSize } from '@hotjar/webapp/features/Activation/hooks/usePersonalisation';
import { TESTIMONIALS as ALL_TESTIMONIALS } from './data/testimonials';
import type { Testimonial } from './data/testimonials';

type GetTestimonialArgs = {
  size?: OrganizationSizeValue;
  role?: OrganizationRoleValue;
};

const findTestimonial = (key: string) =>
  ALL_TESTIMONIALS.find((testimonial) => testimonial.key === key);

export const getTestimonial = ({ size, role }: GetTestimonialArgs): Testimonial | undefined => {
  if (size) {
    const companySize = getGroupedOrgSize(size);

    switch (companySize) {
      case 'org-small':
        return findTestimonial('dmytro-k');
      case 'org-mid':
        return findTestimonial('andrew-h');
      case 'org-large':
        return findTestimonial('dave-p');

      default:
        return findTestimonial('dmytro-k');
    }
  } else if (role) {
    switch (role) {
      case 'digital marketer':
        return findTestimonial('anna-g');

      case 'product manager':
      case 'ceo':
      case 'consultant':
      case 'data analyst':
      case 'other':
        return findTestimonial('gavin-b');

      case 'product designer':
      case 'content designer':
      case 'ux researcher':
        return findTestimonial('piotr-s');

      case 'engineer':
        return findTestimonial('jacob-pitcher');

      default:
        return findTestimonial('gavin-b');
    }
  }

  return undefined;
};
